import React, { useState, useEffect, useRef } from 'react';
import './Navbar.css';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png'; // Adjust path if your structure is different

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [submenuOpen, setSubmenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const navRef = useRef(null);
  const hamburgerRef = useRef(null);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const toggleSubmenu = () => setSubmenuOpen((prev) => !prev);
  const closeMenu = () => {
    setMenuOpen(false);
    setSubmenuOpen(false);
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        menuOpen &&
        navRef.current &&
        !navRef.current.contains(e.target) &&
        hamburgerRef.current &&
        !hamburgerRef.current.contains(e.target)
      ) {
        closeMenu();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [menuOpen]);

  // Detect screen resize to switch between mobile and desktop submenu behavior
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <header className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo"> <Link to="/">
    <img src={logo} alt="NovaCrest Logo" className="navbar-logo-img" />
  </Link></div>

        <nav
          className={`navbar-links ${menuOpen ? 'active' : ''}`}
          ref={navRef}
        >
          <Link to="/" onClick={closeMenu}>Home</Link>
          <Link to="/about" onClick={closeMenu}>About</Link>

          <div
            className="navbar-submenu-wrapper"
            onMouseEnter={() => !isMobile && setSubmenuOpen(true)}
            onMouseLeave={() => !isMobile && setSubmenuOpen(false)}
          >
            <button
              className="submenu-toggle"
              onClick={(e) => {
                if (isMobile) {
                  e.preventDefault();
                  toggleSubmenu();
                }
              }}
            >
              Services ▾
            </button>
            <div className={`submenu ${submenuOpen ? 'open' : ''}`}>
              
         
          <Link to="/services" onClick={closeMenu}>All Services</Link>
             
              <Link to="/ai" onClick={closeMenu}>AI & Machine Learning</Link>
              <Link to="/custom-software" onClick={closeMenu}>Web & Software Development</Link>
              <Link to="/mobile-app" onClick={closeMenu}>Mobile Applications</Link>
               <Link to="/cloud" onClick={closeMenu}>Cloud Solutions</Link>
               <Link to="/managed-it" onClick={closeMenu}>Managed IT  </Link>
               <Link to="/cybersecurity" onClick={closeMenu}>Cyber Security</Link> 
               <Link to="/digitalmarketing" onClick={closeMenu}>Digital Marketing</Link>
                <Link to="/bookkeeping" onClick={closeMenu}>Book Keeping</Link>
                <Link to="/graphics" onClick={closeMenu}>Graphic & AI-Driven Design</Link>
              
              

          
            </div>
          </div>
          <Link to="/projects" onClick={closeMenu}>Projects</Link>
      
          <Link to="/contact-us" onClick={closeMenu}>Contact</Link>
        </nav>

        <div
          className={`hamburger ${menuOpen ? 'open' : ''}`}
          onClick={toggleMenu}
          ref={hamburgerRef}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
